<script lang="ts">
</script>

<!-- Footer -->
<footer class="border-t pt-8 text-center">
	<p class="text-sm text-muted-foreground">
		Created by
		<a
			href="https://ronan.eth.limo"
			target="_blank"
			rel="noopener noreferrer"
			class="underline hover:text-foreground"
		>
			Ronan Sandford
		</a>
	</p>
</footer>
